import { alertConstants } from '../../constants'

const initialState = {
  title: '',
  type: '',
  message: '',
  isShow: false,
  isConfirm: false,
  params: '',
  isAuthenticateError: false,
}

export default function alert(state = initialState, action) {

  switch (action.type) {
    
    case alertConstants.SUCCESS:
      if (state.isAuthenticateError) {
        return state;
      }

      return {
        ...state,
        type: "SUCCESS",
        title: action.params.title,
        message: action.params.message,
        params: action.params,
        isShow: !state.isShow,
        isAuthenticateError: action.params?.isAuthenticateError
      }

    case alertConstants.ERROR:
      if (state.isAuthenticateError) {
        return state;
      }

      return {
        ...state,
        type: "ERROR",
        title: action.params.title,
        message: action.params.message,
        params: '',
        isShow: !state.isShow
      }

    case alertConstants.CONFIRM:
      if (state.isAuthenticateError) {
        return state;
      }

      return {
        ...state,
        type: "CONFIRM",
        title: action.params.title,
        message: action.params.message,
        params: action.params,
        isShow: !state.isShow
      }

    case alertConstants.CLEAR:
      return {
        ...state,
        type: "CLEAR",
        isShow: !state.isShow,
        isAuthenticateError: false
      }

    case alertConstants.INFO:  
      return {
        ...state,
        type: "INFO",
        title: action.params.title,
        message: action.params.message,
        params: '',
        isShow: !state.isShow
      }
    default:
      return state
  }
}